import useAuthentication from "@hooks/useAuthentication";
import EmrLandingPageV2 from "./emrLandingV2";
import EmrLandingPage from ".";



 const GrantsForEmrLanding = ({ path }: { path?: string }) => {
    const { user } = useAuthentication();
    const qatar = user?.region == "QATAR_REGION";

    return (
        <div>
            {qatar ? <EmrLandingPageV2 path={path} /> : <EmrLandingPage path={path} />}
        </div>
    );
};

export default GrantsForEmrLanding;